import { useCallback, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';

import { debounce } from 'lodash';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';
import NewsController from '../../apis/controller/news.controller';
import { dateFormat } from '../../Components/helper/date';
import { charLimit, stripTags } from '../../Components/helper/General';
import { renderImage } from '../../Components/helper/image';
import PageTitle from '../../Components/PageTitle';

function NewsPage() {
    const [keyword, setSearch] = useState('');
    const [news, setNews] = useState();
    const [newsCategory, setNewsCategory] = useState();
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [breadCrumbs, setBreadcrumbs] = useState();
    useEffect(() => {
        window.scrollTo(0, 0);
        getNews('', [], 1);
        getNewsCategory();
        window.onscroll = function(ev) {
            if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight) {
              // you're at the bottom of the page
            //   console.log("Bottom of page");
              getMore();
            }
        };

        return () => {
            window.onscroll = null;
        }
    }, []);


    useEffect(() => {
        console.log("UPDATED PAGE VALUE", page)
        setPage(page)
    }, [page])
    // const getNews = async (search, data) => {
    //     let post = {
    //         search: search,
    //         categories: data,
    //     };
    //     setLoader(true);
    //     let res = await new NewsController().newsListing(post);
    //     if (res && res.status) {
    //         setNews(res.news);
    //     }
    //     setLoader(false);
    // };

    const getNews = async (search, data, page) => {
        let post = {
            search: search,
            categories: data,
            page: page,
        };
        
        if(!loader)
        {
            setLoader(true);
            let response = await new NewsController().newsListing(post);
            if (response && response.status) {
                setBreadcrumbs(response.breadcrumb);
                let list = response.news;
                if (list.length > 0) {
                    if (page === 1) {
                        setNews(list);
                    } else {
                        setNews([...news, ...list]);
                    }
                    setPagination(true);
                    setPage(page + 1);
                } else {
                    setPagination(false);
                    if (page === 1) {
                        setNews([]);
                    }
                }
            }
            setFetching(false);
            setLoader(false);
        }
    };

    const getNewsCategory = async () => {
        setLoader(true);
        let res = await new NewsController().newsCategories();
        if (res && res.status) {
            setNewsCategory(res.news);
        }
        setLoader(false);
    };

    const addItem = (item) => {
        let ids = [];
        if (item && item.id) {
            ids.push(item.id);
        }
        getNews('', ids, 1);
    };

    const getMore = async () => {
        console.log("*************", page)
        if (pagination) {
            // setFetching(true);
            getNews('', [], page);
        }
    };

    const search = useCallback(debounce(getNews, 1000), []);
    return (
        <>
            {breadCrumbs ? <PageTitle title={breadCrumbs.main_title} image={breadCrumbs.image} /> : null}
            <div className="page_content_section">
                <div className="news_page_section bg-light pt-5 pb-5">
                    <Container>
                        <Row>
                            <Col>
                                <div className="news_page_area">
                                    <Row>
                                        {newsCategory ? <Col xl={4} lg={4} md={5} sm={12} xs={12}>
                                            <div className="news_sidebar pt-4">
                                                <div className="shadowed_whitebox p-3 p-lg-4 newspage_search mb-4">
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" placeholder="Search For..."
                                                            value={keyword}
                                                            onChange={e => {
                                                                setSearch(e.target.value);
                                                                search(e.target.value)
                                                            }}
                                                        />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-outline-secondary" type="button">
                                                                <i className="far fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <Events /> */}
                                                <div className="shadowed_whitebox p-3 p-lg-4 news_categories mb-4">
                                                    <div className="sidebar_title">
                                                        Categories
                                                        <hr />
                                                    </div>
                                                    <ul>
                                                        {newsCategory.map((item, index) => (

                                                            <li key={index} onClick={() => addItem(item)}>
                                                                <Link to="#">{item.title}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col> : null}
                                        <Col xl={8} lg={8} md={7} sm={12} xs={12}>
                                            {news && <div className="news_listing pt-4">
                                                <EqualHeight>
                                                    <Row>
                                                        {news.map((item, index) => (
                                                            <Col xl={6} lg={6} md={12} sm={6} xs={12}>
                                                                <div key={index} className="news_item">
                                                                    <EqualHeightElement>
                                                                        <div className="img_area embed-responsive embed-responsive-4by3">
                                                                            <img src={renderImage(item.image, 'large')} className="embed-responsive-item img-fluid" alt="..." />
                                                                            <div className="upper_img">
                                                                                <div className="secondary_btn">
                                                                                    <Link to={{
                                                                                        pathname: "/newsdetail",
                                                                                        id: item.id
                                                                                    }}>Read More</Link>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="news_info">
                                                                            {item.categories.map((item, index) => (

                                                                                <div key={index} className="d-flex align-items-center justify-content-between mb-2">
                                                                                    <div className="news_catg">
                                                                                        <Link to={routes.newsdetail}>{item.title}</Link>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                            <h5>
                                                                                <Link to={routes.newsdetail}>{item.title}</Link>
                                                                            </h5>
                                                                            <p>
                                                                                {charLimit(stripTags(item.description), 200)}
                                                                            </p>
                                                                            <hr />
                                                                            <div className="news_metainfo">
                                                                                <ul>
                                                                                    <li>
                                                                                        <i className="far fa-user"></i>
                                                                                        <span>By {item.owner_first_name} {item.owner_last_name}</span>
                                                                                    </li>
                                                                                    <li>
                                                                                        <i className="far fa-calendar"></i>
                                                                                        <span>{dateFormat(item.created)}</span>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </EqualHeightElement>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </EqualHeight>
                                            </div>}
                                            {/* <div className="pagination_area">
                                                <ReactPaginate
                                                    previousLabel={<i class="far fa-angle-left"></i>}
                                                    nextLabel={<i class="far fa-angle-right" onClick={() => getMore()}></i>}
                                                    pageCount={4}
                                                />
                                            </div> */}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
}

export default NewsPage;
